const BRAND = 'Deem';

export default {
    name: BRAND,
    card: `${BRAND} Card`,
    loan: `${BRAND} Personal Loan`,
    creditCard: `${BRAND} Credit Card`,
    doubleSecure: `${BRAND} Double Secure`,
};